import React, { useMemo } from 'react';

import usePlatformsData from '../../../../../adjust/params-section/hooks/usePlatformsData';
import hexWithAlpha from '../../../../../../../utils/hexWithAlpha';

import scss from './GroupBadge.module.scss';

function GroupBadge({ group, displayValue, ratio }) {
  const { iconColors } = usePlatformsData();
  const iconColor = iconColors[group];
  const backgroundColor = useMemo(() => hexWithAlpha({ hex: iconColor, alpha: 25 }), [iconColor]);
  const cleanedLabel = useMemo(() => stripRatioFromDisplayValue(displayValue, ratio), [displayValue, ratio]);

  if (!cleanedLabel) {
    return null;
  }

  return (
    <div className={scss.badge} style={{ backgroundColor }}>
      <span className={scss.label}>{cleanedLabel}</span>
    </div>
  );
}

export default GroupBadge;

function escapeForRegex(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function stripRatioFromDisplayValue(displayValue, ratio) {
  if (typeof displayValue !== 'string') {
    return null;
  }

  const ratioValue = typeof ratio === 'string' ? ratio.trim() : '';

  if (!ratioValue) {
    return displayValue;
  }

  if (!displayValue.toLowerCase().includes(ratioValue.toLowerCase())) {
    return displayValue;
  }

  const escapedRatio = escapeForRegex(ratioValue);
  let normalizedValue = displayValue
    .replace(new RegExp(`\\s*\\(${escapedRatio}\\)\\s*`, 'gi'), ' ')
    .replace(new RegExp(`\\s*[|/-]\\s*${escapedRatio}\\s*`, 'gi'), ' ')
    .replace(new RegExp(`\\s*${escapedRatio}\\s*[|/-]\\s*`, 'gi'), ' ')
    .replace(new RegExp(`(^|\\s)${escapedRatio}(?=\\s|$)`, 'gi'), '$1')
    .replace(/\s{2,}/g, ' ')
    .replace(/\s*([|/-])\s*$/g, '')
    .replace(/^\s*([|/-])\s*/g, '')
    .replace(/\s*,\s*$/g, '')
    .trim();

  if (!normalizedValue) {
    normalizedValue = displayValue;
  }

  return normalizedValue;
}
